import React, { useEffect, useState } from "react";
import Search from "../api/Search";
import MovieCard from "./MovieCard";
import { Link, useParams } from "react-router-dom";
import { Grid, Typography, CircularProgress, Box } from "@mui/material";
import "../App.css";

const MAX_QUERY_DISPLAY = 80;

const truncate = (text) =>
  text.length > MAX_QUERY_DISPLAY
    ? `${text.slice(0, MAX_QUERY_DISPLAY)}…`
    : text;

const SearchRes = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { query } = useParams();

  useEffect(() => {
    if (!query) return undefined;
    const controller = new AbortController();
    setLoading(true);
    setError(null);
    Search(query, { signal: controller.signal })
      .then((response) => {
        setData(response.data.results || []);
      })
      .catch((err) => {
        if (err?.name === 'CanceledError' || err?.name === 'AbortError') return;
        setError("Could not load results. Please try again.");
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
    return () => controller.abort();
  }, [query]);

  const safeQuery = truncate(query || '');

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6" sx={{ color: 'white' }} role="alert">{error}</Typography>
      </Box>
    );
  }

  return (
    <div>
      <Typography variant="h1" sx={{ color: 'white', fontSize: '1.5rem', mb: 2 }}>
        Search Results for "{safeQuery}"
      </Typography>
      {data.length === 0 ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <Typography variant="h2" sx={{ color: 'white', fontSize: '1.25rem', mb: 2 }}>
            No results found
          </Typography>
          <Typography sx={{ color: '#B3B3B3' }}>
            Try different keywords or check spelling
          </Typography>
        </Box>
      ) : (
        <>
          <Typography sx={{ color: '#B3B3B3', mb: 2 }}>
            {data.length} movie{data.length === 1 ? '' : 's'} found
          </Typography>
          <Grid container spacing={2}>
            {data.map((movie) => (
              <Grid className="Link" item xs={6} sm={4} md={3} lg={2} key={movie.id}>
                <Link to={`/movie/${movie.id}`} aria-label={`View details for ${movie.title || movie.original_name}`}>
                  <MovieCard data={movie} />
                </Link>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </div>
  );
};

export default SearchRes;
